import "core-js/modules/es.object.assign.js";
import fetch from './fetch';
// method:POST Content-Type: application/x-www-form-urlencoded
export var postByForm = function postByForm(url, option) {
  var config = Object.assign({}, option || {}, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
  return fetch(url, config);
};

// method:GET Content-Type: application/x-www-form-urlencoded
export var getByForm = function getByForm(url, option) {
  var config = Object.assign({}, option || {}, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
  return fetch(url, config);
};

// method:POST Content-Type: application/json
export var postByJSON = function postByJSON(url, option) {
  var config = Object.assign({}, option || {}, {
    method: 'POST'
  });
  return fetch(url, config);
};

// method:GET Content-Type: application/json
export var getByJSON = function getByJSON(url, option) {
  return fetch(url, option);
};

// method:POST Content-Type: multipart/form-data
export var postByFormData = function postByFormData(url, option) {
  var config = Object.assign({}, option || {}, {
    method: 'POST',
    headers: {
      'Content-Type': 'false'
    }
  });
  return fetch(url, config);
};
export default fetch;